// Packaging.Ref — version-level reference to a Packaging.
export { mk };
const mk = (id, version) => ({
    type: "packaging_ref",
    id,
    version,
});
//# sourceMappingURL=ref.js.map